module.exports = __webpack_public_path__ + "static/media/rn_logo.b45a50e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/rn_logo.jpg
// module id = 25
// module chunks = 0